// src/PublicApp.tsx
//
// Minimal app shell for public link-in-bio pages served at bandjerry.link/{slug}.
// No React Router, no Amplify, no TanStack Query, no Zustand — just reads the
// slug from the URL path and renders the public page component.

import PublicLinkInBioPage from '@/pages/PublicLinkInBioPage';

function extractSlug(): string {
  // URL is bandjerry.link/{slug} — strip leading slash
  const path = window.location.pathname;
  const slug = path.replace(/^\/+/, '').replace(/\/+$/, '');
  return slug;
}

export default function PublicApp() {
  const slug = extractSlug();

  if (!slug) {
    // Root path with no slug — redirect to main site
    window.location.href = 'https://www.bandjerry.com';
    return null;
  }

  return <PublicLinkInBioPage slug={slug} />;
}
